/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MarketItemsInner } from './marketItemsInner';

export interface GetMarketItemsData {
  items: Array<MarketItemsInner>;
  page_token?: string;
  next_page_token?: string;
  prev_page_token?: string;
}
